// extracted by mini-css-extract-plugin
export default {"table":"table_table__whMCp","actions":"table_actions__Ar-Eo","circular-status":"table_circular-status__X2BKD"};